<template>
  <div class="page-wrapper">
    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <!--<Col span="6">-->
          <!--<Select v-model="searchData.projectFid"  placeholder="项目名称">-->
            <!--<Option value=''>请选择</Option>-->
            <!--<Option v-for="(item,index) in projectListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
          <!--</Select>-->
        <!--</Col>-->
        <!--<Col span="3">-->
          <!--<Select v-model="searchData.feedbackName" placeholder="反馈来源">-->
            <!--<Option value=''>请选择</Option>-->
            <!--<Option v-for="(item,index) in monthList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
          <!--</Select>-->
        <!--</Col>-->
        <!--<Col span="6">-->
          <!--<DatePicker style="width:100%" v-model="searchData.createTime" format="yyyy-MM-dd" split-panels type="daterange" placeholder="创建日期筛选"></DatePicker>-->
        <!--</Col>-->
        <Col span="5">
          <Input placeholder="小区名称" v-model="searchData.communityCommunity"></Input>
        </Col>
        <Col span="5">
        <Input placeholder="业主电话" v-model="searchData.mobileDecode"></Input>
        </Col>
        <Col span="5" class="flex">
        <span class="flexnone">租价:</span>
        <InputNumber
                class="flexauto"
                v-model="searchData.leasePriceForm"
                :min="0"
                :max="searchData.leasePriceTo"
                @on-change="changeFrom1"
        ></InputNumber>-
        <InputNumber
                class="flexauto"
                v-model="searchData.leasePriceTo"
                :min="searchData.leasePriceForm"
                :max="9999999"
                @on-change="changeTo1"
        ></InputNumber>
        </Col>
        <Col span="5" class="flex">
        <span class="flexnone">售价:</span>
        <InputNumber
                class="flexauto"
                v-model="searchData.highPriceForm"
                :min="0"
                :max="searchData.highPriceTo"
                @on-change="changeFrom2"
        ></InputNumber>-
        <InputNumber
                class="flexauto"
                v-model="searchData.highPriceTo"
                :min="searchData.highPriceForm"
                :max="9999999"
                @on-change="changeTo2"
        ></InputNumber>
        </Col>
        <Col span="6">
        <DatePicker style="width:100%" v-model="searchData.createdAt" format="yyyy-MM-dd" split-panels type="daterange" placeholder="创建挂盘时间"></DatePicker>
        </Col>
      </Row>
    </search-group>

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
      <Button type="primary" class="btn" @click="exportGoods" v-p="{api:'archives/batchImport'}">批量导入</Button>
    </table-list>
    <batch-import-modal :n="importKey" @ok="getData"></batch-import-modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  // import {formatDateTime} from "../../../../../utils/format";
  import {formatDateTime} from "../../../utils/format";
  import TableList from 'components/TableList/index';
  import {mapGetters} from 'vuex'
  import {getHouseDatalist} from "../../../api/feedback";
import { refund } from '../../../api/book';
  import BatchImportModal from './components/BatchImportModal';

  export default {
    condition:'advice',
    components: {
      SearchGroup,
      TableList,
      BatchImportModal
    },
    mounted() {
      // getOpinionFeedbackEnumv1().then(res=>{
      //   if(!res.data){
      //     return
      //   }
      //   this.monthList=res.data
      //
      // }).catch(error=>{})

      this.findData()


    },
    computed: {
      ...mapGetters(['projectList']),
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
            communityCommunity: this.searchData.communityCommunity,
            startTime: f(this.searchData.createdAt[0]),
            endTime:f(this.searchData.createdAt[1]),
            mobileDecode:this.searchData.mobileDecode,
            leasePriceForm:this.searchData.leasePriceForm,
            leasePriceTo:this.searchData.leasePriceTo,
            highPriceForm:this.searchData.highPriceForm,
            highPriceTo:this.searchData.highPriceTo
        }
      }
    },
    watch: {
      projectList() {
        this.projectListData = this.projectList
      }
    },
    data() {
      return {
        infoN:0,
        importKey:0,
        itemData:null,
        projectListData:[],
        monthList:[],
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center',
          },
          {
            title: '房源ID',
            key: 'houseId',
            width: 100,
          },
          {
            title: '房源UUID',
            key: 'uuid',
            width: 180,
          },

          {
            title: '机构房源id',
            key: 'agencyHouseId',
            width: 100,
          },
          {
            title: "城市id",
            key: 'cityId',
            width: 90,
          },
          {
              title: "行政区域id",
              key: 'districtId',
              width: 110,
          },
          {
            title: '商圈id',
            key: 'businessId',
            width: 90,

          },
          {
            title: '小区id',
              key: 'communityId',
              width: 110,
          },
            {
                title: '行政区名称',
                key: 'districtName',
                width: 120,
            },
            {
                title: '商圈名称',
                key: 'businessName',
                width: 120,
            },
            {
                title: '小区地址',
                key: 'communityAddress',
                width: 180,
            },
            {
                title: '小区名称(楼盘)',
                key: 'communityCommunity',
                width: 150,
            },
            {
                title: '楼栋',
                key: 'agencyHouseRidgepoleName',
                width: 90,
            },
            {
                title: '所在层',
                key: 'agencyHouseFloorName',
                width: 90,
            },
            {
                title: '总层数',
                key: 'agencyHouseTotalFloor',
                width: 90,
            },
            {
                title: '展示楼层',
                key: 'agencyHouseFloorTitle',
                width: 90,
            },
            {
                title: '结构类型(多层、高层)',
                key: 'agencyHouseArchType',
                width: 120,
            },
            {
                title: '装修类型',
                key: 'agencyHouseDecorationLevel',
                width: 100,
            },
            {
                title: '朝向',
                key: 'agencyHouseDirection',
                width: 100,
            },
            {
                title: '面积',
                key: 'agencyHouseArchSquare',
                width: 100,
            },
            {
                title: '房间数量',
                key: 'agencyHouseRoom',
                width: 100,
            },
            {
                title: '客厅数量',
                key: 'agencyHouseHall',
                width: 100,
            },
            {
                title: '楼栋类型',
                key: 'agencyHouseCommunityType',
                width: 100,
            },
            {
                title: '楼栋结构',
                key: 'agencyHouseArchStructure',
                width: 100,
            },
            {
                title: '交房年份',
                key: 'agencyHouseDelivery',
                width: 100,
            },
            {
                title: '业主电话',
                key: 'mobileDecode',
                width: 120,
            },
            {
                title: '创建挂盘时间',
                key: 'createdAt',
                width: 120,
                render:(h,params)=>{
                    return h('span',{},formatDateTime(params.row['createdAt'],false))

                }
            },
            {
                title: '交易类型(出租、出售、租售)',
                key: 'category',
                width: 120,
            },
            {
                title: '居室',
                key: 'structure',
                width: 120,
            },
            {
                title: '出售价格',
                key: 'highPrice',
                width: 120,
            },
            {
                title: '单平米出售价格',
                key: 'saleUnitPrice',
                width: 120,
            },
            {
                title: '出售最低价格',
                key: 'lowPrice',
                width: 120,
            },
          {
            title: "出租价格",
            key: 'leasePrice',
            width: 100,
          },
          {
              title: "单平米出租价格",
              key: 'leaseUnitPrice',
              width: 120,
          },
            {
                title: "出租最低价格",
                key: 'lowLeasePrice',
                width: 120,
            },
            {
                title: "是否独家",
                key: 'isOrderOnlyStr',
                width: 100,
            },
            {
                title: "是否实勘",
                key: 'isSurveyStr',
                width: 100,
            },
            {
                title: "是否有照片",
                key: 'ifPicStr',
                width: 100,
            },
            {
                title: "是否学区",
                key: 'isSchoolStr',
                width: 100,
            },
            {
                title: "是否有地铁",
                key: 'isSubwayStr',
                width: 100,
            },
            {
                title: "点击数量",
                key: 'clickNum',
                width: 100,
            },
            {
                title: "房屋状态",
                key: 'leaseStatus',
                width: 100,
            },
            {
                title: "最后呼出时间",
                key: 'lastCalledAt',
                width: 120,
                render:(h,params)=>{
                return h('span',{},formatDateTime(params.row['lastCalledAt'],false))

               }
            },
            {
                title: "售价涨跌",
                key: 'salePriceDiff',
                width: 120,
            },
            {
                title: "租价涨跌",
                key: 'leasePriceDiff',
                width: 120,
            },
            {
                title: "备注",
                key: 'summary',
                width: 120,
            },
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
            communityCommunity: '',
            createdAt:['',''],
            mobileDecode:'',
            leasePriceForm: 0,
            leasePriceTo: 9999999,
            highPriceForm: 0,
            highPriceTo: 9999999
          // feedbackName:''

        },
      }
    },
    methods: {
      getData(){
        const params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
          getHouseDatalist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total

          // res.data.rows = res.data.rows.map(item => {
          //
          //   if(item.text.length > 120 ){
          //     item.expandText = true
          //     item.expandTextButton = true;
          //   }else{
          //     item.expandText = false;
          //     item.expandTextButton = false;
          //   }
          //   return item;
          // })
          this.data=res.data.rows?res.data.rows:[]
        }).catch(error=>{
        })

      },
      exportGoods() {
          this.importKey++
      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
            communityCommunity: '',
          createdAt:['',''],
          mobileDecode:''
          // feedbackName:''
        }
      },
      changeTableRowTextExpandState(i){
        this.data = this.data.map(( item,index ) => {
          if( i === index ){
            item.expandText = !item.expandText
          }
          return item;
        })
      },
      changeFrom1(value) {
          if (value > this.searchData.serviceScoreTo) {
              this.searchData.serviceScoreFrom = this.searchData.serviceScoreTo;
          }
      },
      changeTo1(value) {
          if (value < this.searchData.serviceScoreFrom) {
              this.searchData.serviceScoreTo = this.searchData.serviceScoreFrom;
          }
      },
      changeFrom2(value) {
          if (value > this.searchData.highPriceTo) {
              this.searchData.highPriceTo = this.searchData.highPriceForm;
          }
      },
      changeTo2(value) {
          if (value < this.searchData.highPriceForm) {
              this.searchData.highPriceTo = this.searchData.highPriceForm;
          }
      }
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .wrappertabs{
    min-height: 400px;
  }
</style>
<style>
  .feedback-text-wrapper{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .feedback-text-container > .ivu-table-cell > div{
    padding: 10px 0;
    overflow: hidden;
  }
</style>